export const INITIALIZE = 'com.Handy.common.INITIALIZE';
export const SET_LOADING = 'com.Handy.common.SET_LOADING';
export const SET_SIDEMENU_OPEN = 'com.Handy.common.SET_SIDEMENU_OPEN';
export const CLEAR = 'com.Handy.common.CLEAR';
export const CHECK_IS_MOBILE = 'com.Handy.common.CHECK_IS_MOBILE';
export const CHECK_LOCALE = 'com.Handy.common.CHECK_LOCALE';
